









































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Http403 extends Vue {
  get isAuthenticated () {
    return this.$store.getters.isAuthenticated
  }
}
